import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Product } from '../../types/product.type';
import { UserSelections } from '../../types/user-details.type';

@Injectable({
    providedIn: 'root'
})
export class UserSelectionsService {
    selections: UserSelections = {};
    public currentSelections$: BehaviorSubject<UserSelections> = new BehaviorSubject<UserSelections>(null);
    public currentProductSelections$: BehaviorSubject<Product> = new BehaviorSubject<Product>(null);


    constructor(
    ) {
    }

    set(type: string, data: any) {
        this.selections[type] = data;
        this.currentSelections$.next(this.selections);
        if (type == 'product') {
            this.currentProductSelections$.next(this.selections.product);
        }
    }

    get(type: string) {
        if (this.selections[type] !== undefined) {
            return this.selections[type];
        } else {
            return null;
        }
    }

    remove(type: string) {
        delete this.selections[type];
        this.currentSelections$.next(this.selections);
    }

    removeAll() {
        this.selections = {};
        this.currentSelections$.next(this.selections);
    }
}
